import { useState, useEffect } from "react";
import {
  Page, Left, Right, HeaderRow,
  RoleListContainer, RoleItem, SearchInput,
} from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import { toast } from "react-toastify";
import { fetchReportes, fetchReporteFull, guardarReporte, fetchTiposDatoReporte } from "../../../../api/ReportGeneratorApi";

const TIPO_COMBO_OPTIONS = [
  { value: 0, label: "Ninguno" },
  { value: 1, label: "Lista fija" },
  { value: 2, label: "Consulta SQL" },
];

const emptyForm = {
  id: null, nombre: "", descripcion: "",
  query_base: "", query_group: "", query_order: "", esSP: 0,
  estado: 1, orden: 10,
  filtros: [], columnas: [],
};

const emptyFiltro = {
  label: "", condicion_sql: "", tipo_dato: "text",
  requerido: 0, orden: 0,
  tipoCombo: 0, sql_combo: "",
  dependeDe: null, esDependiente: 0,
  opciones: [],
};

const emptyColumna = { label: "", campo_resultado: "", tipo_dato: "text", orden: 0, visible: 1 };
const emptyOpcion = { value: "", descripcion: "", orden: 0, valor_padre: null };

/* ─── Acordeón ─── */
function Accordion({ title, count, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ marginBottom: "6px", border: "1px solid #e2e8f0", borderRadius: "6px" }}>
      <button onClick={() => setOpen(!open)} style={{
        width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "5px 10px", background: open ? "#f1f5f9" : "#f8fafc",
        border: "none", borderRadius: open ? "6px 6px 0 0" : "6px",
        cursor: "pointer", fontSize: "11px", fontWeight: "600", color: "#1e40af",
      }}>
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {title}
          {count != null && <span style={{ background: "#dbeafe", color: "#2563eb", borderRadius: "10px", padding: "0 6px", fontSize: "10px", fontWeight: "700" }}>{count}</span>}
        </span>
        <span style={{ fontSize: "10px", color: "#94a3b8" }}>{open ? "▲" : "▼"}</span>
      </button>
      {open && <div style={{ padding: "6px 8px", borderTop: "1px solid #e2e8f0" }}>{children}</div>}
    </div>
  );
}

/* ─── Modal de opciones fijas ─── */
function ComboOptionsModal({ filtro, filtroIdx, onClose, onSave }) {
  const [opciones, setOpciones] = useState(
    (filtro.opciones || []).map((o) => ({ ...emptyOpcion, ...o }))
  );

  const addOpcion = () => setOpciones((p) => [
    { ...emptyOpcion, orden: p.length + 1 }, ...p
  ]);

  const removeOpcion = (i) => setOpciones((p) => p.filter((_, idx) => idx !== i));

  const changeOpcion = (i, field, val) => {
    const l = [...opciones];
    l[i] = { ...l[i], [field]: val };
    setOpciones(l);
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: "10px", width: "560px", maxHeight: "80vh", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>
        {/* Header modal */}
        <div style={{ padding: "12px 16px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontWeight: "600", fontSize: "13px", color: "#1e40af" }}>
            Opciones: <em>{filtro.label || `Filtro ${filtroIdx + 1}`}</em>
          </span>
          <div style={{ display: "flex", gap: "8px" }}>
            <BtnGeneral bg="teal" padding="4px 10px" radius="4px" fs="11px" fw="600" onClick={addOpcion}>
              + Añadir
            </BtnGeneral>
            <BtnGeneral bg="green" padding="4px 14px" radius="4px" fs="11px" fw="600" onClick={() => onSave(filtroIdx, opciones)}>
              Guardar
            </BtnGeneral>
            <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: "18px", lineHeight: 1 }}>✕</button>
          </div>
        </div>
        {/* Body modal */}
        <div style={{ overflowY: "auto", padding: "10px 14px" }}>
          {opciones.length === 0 ? (
            <p style={{ color: "#94a3b8", fontSize: "12px", textAlign: "center", padding: "20px 0" }}>
              Sin opciones. Haz clic en "+ Añadir".
            </p>
          ) : (
            <table style={{ ...tbl, borderCollapse: "separate", borderSpacing: "0 3px" }}>
              <thead>
                <tr>
                  <th style={th}>Valor (value)</th>
                  <th style={th}>Descripción</th>
                  <th style={th}>Orden</th>
                  <th style={{ ...th, width: "28px" }}></th>
                </tr>
              </thead>
              <tbody>
                {opciones.map((op, i) => (
                  <tr key={i}>
                    <td style={td}><input style={inpSm} value={op.value} placeholder="F" onChange={(e) => changeOpcion(i, "value", e.target.value)} /></td>
                    <td style={td}><input style={inpSm} value={op.descripcion} placeholder="Femenino" onChange={(e) => changeOpcion(i, "descripcion", e.target.value)} /></td>
                    <td style={td}><input type="number" style={{ ...inpSm, width: "50px" }} value={op.orden} onChange={(e) => changeOpcion(i, "orden", parseInt(e.target.value) || 0)} /></td>
                    <td style={{ ...td, textAlign: "center" }}><button onClick={() => removeOpcion(i)} style={btnDel}>✕</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─── Componente principal ─── */
export default function ReportManager() {
  const [reportes, setReportes] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const [expandedFiltro, setExpandedFiltro] = useState(null);
  const [comboModalFiltro, setComboModalFiltro] = useState(null);
  const [leftOpen, setLeftOpen] = useState(true);
  const [tiposDato, setTiposDato] = useState([]);

  useEffect(() => {
    fetchReportes().then(setReportes).catch(() => toast.error("Error al cargar reportes"));
    fetchTiposDatoReporte().then(setTiposDato).catch(console.error);
  }, []);

  const handleNew = () => { setSelected(null); setForm(emptyForm); setExpandedFiltro(null); setComboModalFiltro(null); };

  const handleSelect = async (r) => {
    setSelected(r.reporte_id);
    setExpandedFiltro(null);
    setComboModalFiltro(null);
    setLoading(true);
    try {
      const full = await fetchReporteFull(r.reporte_id);
      if (!full) throw new Error();
      const parsedEsSP = (Number(full.esSP) === 1 || full.esSP === true || full.esSP === "1") ? 1 : 0;
      setForm({
        ...emptyForm,
        ...full,
        id: full.id || r.reporte_id,
        esSP: parsedEsSP,
        filtros: full.filtros || [],
        columnas: full.columnas || [],
      });
    } catch { toast.error("Error al cargar el reporte"); setSelected(null); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    if (!form.nombre?.trim() || !form.query_base?.trim()) { toast.warning("Nombre y Consulta Base son obligatorios"); return; }

    if (!form.query_base.includes("{{Empresa}}")) {
      toast.error("Por seguridad, la Consulta Base debe contener la etiqueta obligatoria {{Empresa}} para filtrar los datos.");
      return;
    }

    try {
      const res = await guardarReporte(form);
      if (res.success) {
        toast.success("Guardado");
        const updated = await fetchReportes();
        setReportes(updated);
        const newId = res.data?.id || form.id;
        setForm((p) => ({ ...p, id: newId }));
        setSelected(newId);
      } else toast.error(res.mensaje || "Error al guardar");
    } catch { toast.error("Error técnico"); }
  };

  // ── Filtros ──
  const addFiltro = () => {
    setForm((p) => ({ ...p, filtros: [{ ...emptyFiltro }, ...p.filtros] }));
    setExpandedFiltro(0);
  };
  const removeFiltro = (i) => {
    setForm((p) => ({ ...p, filtros: p.filtros.filter((_, idx) => idx !== i) }));
    setExpandedFiltro(null);
  };
  const changeFiltro = (i, f, v) => {
    setForm((p) => {
      const l = [...p.filtros];
      l[i] = { ...l[i], [f]: v };
      // Limpiar combos si deja de ser select o multi-select
      if (f === "tipo_dato" && v !== "select" && v !== "multi-select") {
        l[i] = { ...l[i], tipoCombo: 0, sql_combo: "", dependeDe: null, esDependiente: 0 };
      }
      // Limpiar dependeDe si se desmarca "Es Dependiente"
      if (f === "esDependiente" && v === 0) {
        l[i] = { ...l[i], dependeDe: null };
      }
      return { ...p, filtros: l };
    });
  };

  // Guardar opciones desde el modal
  const handleSaveOpciones = (filtroIdx, opciones) => {
    const l = [...form.filtros];
    l[filtroIdx] = { ...l[filtroIdx], opciones };
    setForm((p) => ({ ...p, filtros: l }));
    setComboModalFiltro(null);
    toast.success(`Opciones guardadas (se aplicarán al guardar el reporte)`);
  };

  // ── Columnas ──
  const addColumna = () => setForm((p) => ({ ...p, columnas: [{ ...emptyColumna }, ...p.columnas] }));
  const removeColumna = (i) => setForm((p) => ({ ...p, columnas: p.columnas.filter((_, idx) => idx !== i) }));
  const changeColumna = (i, f, v) => {
    const l = [...form.columnas]; l[i] = { ...l[i], [f]: v }; setForm((p) => ({ ...p, columnas: l }));
  };

  const filtered = reportes.filter((r) => (r.nombre || "").toLowerCase().includes(search.toLowerCase()));

  return (
    <Page style={{ gap: leftOpen ? "18px" : "0px", transition: "gap 0.2s ease" }}>
      {/* ── PANEL IZQUIERDO ── */}
      <Left style={{
        width: leftOpen ? undefined : "0px",
        minWidth: leftOpen ? undefined : "0px",
        maxWidth: leftOpen ? undefined : "0px",
        flex: leftOpen ? undefined : "0 0 0px",
        padding: leftOpen ? undefined : "0",
        border: leftOpen ? "1px solid #e2e8f0" : "none",
        background: leftOpen ? "#fff" : "transparent",
        overflow: "hidden",
        transition: "width 0.2s ease, min-width 0.2s ease, max-width 0.2s ease, flex 0.2s ease, padding 0.2s ease",
        position: "relative",
      }}>
        <div style={{ minWidth: "220px" }}>
          <HeaderRow>
            <h3 style={{ margin: 0, fontSize: "13px" }}>Reportes</h3>
            <BtnGeneral bg="cyan" padding="4px 8px" radius="5px" fw="600" fs="11px" onClick={handleNew}>Nuevo</BtnGeneral>
          </HeaderRow>

          <SearchInput placeholder="Buscar..." value={search} onChange={(e) => setSearch(e.target.value)} />
          <RoleListContainer>
            {filtered.map((r) => (
              <RoleItem key={r.reporte_id} active={selected === r.reporte_id} onClick={() => handleSelect(r)}>
                <strong style={{ fontSize: "12px" }}>{r.nombre}</strong>
              </RoleItem>
            ))}
          </RoleListContainer>
        </div>
      </Left>

      {/* ── CONTENEDOR DERECHO WRAPPER ── */}
      <div style={{ flex: 1, position: "relative", display: "flex", flexDirection: "column", minWidth: 0 }}>

        {/* BOTÓN TOGGLE IZQUIERDO */}
        <button
          onClick={() => setLeftOpen(!leftOpen)}
          title={leftOpen ? "Ocultar panel" : "Mostrar panel"}
          style={{
            position: "absolute",
            left: leftOpen ? "-12px" : "0px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "#fff",
            border: "1px solid #cbd5e1",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#475569",
            fontSize: "12px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            zIndex: 10,
            transition: "left 0.2s ease",
          }}>
          {leftOpen ? "◀" : "▶"}
        </button>

        {/* ── PANEL DERECHO ── */}
        <Right style={{ flex: 1, overflowY: "auto", padding: "8px 10px" }}>

          <HeaderRow style={{ marginBottom: "6px" }}>
            <span style={{ fontSize: "11px", fontWeight: "600", color: "#334155" }}>
              {form.id ? `Editar: ${form.nombre || "Reporte"}` : "Nuevo Reporte"}
            </span>
            <BtnGeneral bg="green" padding="4px 16px" radius="5px" fw="600" fs="11px" onClick={handleSave} disabled={loading}>
              Guardar
            </BtnGeneral>
          </HeaderRow>

          {loading ? (
            <p style={{ color: "#94a3b8", textAlign: "center", fontSize: "12px" }}>Cargando...</p>
          ) : (
            <>
              {/* ── Datos del Reporte ── */}
              <Accordion title="Datos del Reporte" defaultOpen={true}>
                <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
                  <Row lbl="Nombre:">
                    <input style={inp} value={form.nombre} placeholder="Nombre del reporte"
                      onChange={(e) => setForm({ ...form, nombre: e.target.value })} />
                  </Row>
                  <Row lbl="Descripción:">
                    <input style={inp} value={form.descripcion} placeholder="Descripción corta"
                      onChange={(e) => setForm({ ...form, descripcion: e.target.value })} />
                  </Row>
                  <Row lbl="Consulta Base:" top>
                    <textarea style={{ ...inp, height: "55px", resize: "vertical", fontFamily: "monospace", fontSize: "11px" }}
                      value={form.query_base} placeholder="SELECT * FROM tabla WHERE 1=1"
                      onChange={(e) => setForm({ ...form, query_base: e.target.value })} />
                  </Row>
                  <Row lbl="Group By:">
                    <input style={inp} value={form.query_group ?? ""} placeholder="GROUP BY campo1, campo2"
                      onChange={(e) => setForm({ ...form, query_group: e.target.value })} />
                  </Row>
                  <Row lbl="Order By:">
                    <input style={inp} value={form.query_order ?? ""} placeholder="ORDER BY campo ASC"
                      onChange={(e) => setForm({ ...form, query_order: e.target.value })} />
                  </Row>
                  <Row lbl="">
                    <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
                      <label style={chkLbl}>
                        <input type="checkbox" checked={Number(form.esSP) === 1}
                          onChange={(e) => setForm({ ...form, esSP: e.target.checked ? 1 : 0 })} />
                        Es Stored Procedure
                      </label>
                      <label style={chkLbl}>
                        Estado:&nbsp;
                        <select style={{ ...inp, width: "110px", margin: 0 }} value={form.estado}
                          onChange={(e) => setForm({ ...form, estado: e.target.value })}>
                          <option value={1}>ACTIVO</option>
                          <option value={0}>INACTIVO</option>
                        </select>
                      </label>
                      <label style={chkLbl}>
                        Orden:&nbsp;
                        <input type="number" style={{ ...inp, width: "60px", margin: 0 }} value={form.orden}
                          onChange={(e) => setForm({ ...form, orden: e.target.value })} />
                      </label>
                    </div>
                  </Row>
                </div>
              </Accordion>

              {/* ── Filtros ── */}
              <Accordion title="Filtros" count={form.filtros.length} defaultOpen={true}>
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px" }}>
                  <BtnGeneral bg="teal" padding="3px 10px" radius="4px" fs="11px" fw="600" onClick={addFiltro}>
                    + Añadir
                  </BtnGeneral>
                </div>
                {form.filtros.length > 0 && (
                  <table style={tbl}>
                    <thead>
                      <tr style={{ background: "#f8fafc" }}>
                        <th style={th}>Label</th>
                        <th style={th}>Condición SQL</th>
                        <th style={th}>Tipo</th>
                        <th style={{ ...th, width: "52px" }}>Orden</th>
                        <th style={{ ...th, textAlign: "center", width: "28px" }} title="Requerido">R</th>
                        <th style={{ ...th, width: "28px" }}></th>
                        <th style={{ ...th, width: "28px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {form.filtros.map((f, i) => {
                        const isLista = f.tipo_dato === "select" || f.tipo_dato === "multi-select";
                        return (
                          <>
                            <tr key={`f-${i}`} style={{ borderTop: "1px solid #f1f5f9", background: expandedFiltro === i ? "#fffbeb" : "white" }}>
                              <td style={td}><input style={inpSm} value={f.label} placeholder="Nombre" onChange={(e) => changeFiltro(i, "label", e.target.value)} /></td>
                              <td style={td}><input style={inpSm} value={f.condicion_sql} placeholder={Number(form.esSP) === 1 ? "@variable = {{valor}}" : "AND campo = {{valor}}"} onChange={(e) => changeFiltro(i, "condicion_sql", e.target.value)} /></td>
                              <td style={td}>
                                <select style={inpSm} value={f.tipo_dato} onChange={(e) => changeFiltro(i, "tipo_dato", e.target.value)}>
                                  {tiposDato.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                                </select>
                              </td>
                              <td style={{ ...td, width: "52px" }}>
                                <input type="number" style={{ ...inpSm, width: "48px" }} value={f.orden ?? 0}
                                  onChange={(e) => changeFiltro(i, "orden", parseInt(e.target.value) || 0)} />
                              </td>
                              <td style={{ ...td, textAlign: "center" }}>
                                <input type="checkbox" checked={!!f.requerido} title="Requerido"
                                  onChange={(e) => changeFiltro(i, "requerido", e.target.checked ? 1 : 0)} />
                              </td>
                              <td style={{ ...td, textAlign: "center" }}>
                                {/* Solo mostrar ⋯ si es de tipo Lista */}
                                {isLista && (
                                  <button onClick={() => setExpandedFiltro(expandedFiltro === i ? null : i)}
                                    style={{ ...btnDel, color: "#2563eb", fontSize: "11px" }} title="Opciones avanzadas">⋯</button>
                                )}
                              </td>
                              <td style={{ ...td, textAlign: "center" }}>
                                <button onClick={() => removeFiltro(i)} style={btnDel}>✕</button>
                              </td>
                            </tr>

                            {/* Sub-fila avanzada — solo visible si isLista y expandido */}
                            {isLista && expandedFiltro === i && (
                              <tr key={`fexp-${i}`}>
                                <td colSpan={6} style={{ background: "#fffbeb", padding: "6px 10px", borderBottom: "1px solid #fde68a" }}>
                                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
                                    <label style={chkLbl}>
                                      Tipo Combo:&nbsp;
                                      <select style={{ ...inpSm, width: "120px" }} value={f.tipoCombo ?? 0}
                                        onChange={(e) => changeFiltro(i, "tipoCombo", parseInt(e.target.value))}>
                                        {TIPO_COMBO_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                                      </select>
                                    </label>

                                    {/* SQL Combo — solo si tipoCombo=2 */}
                                    {(f.tipoCombo === 2 || f.tipoCombo === "2") && (
                                      <label style={{ ...chkLbl, alignItems: "flex-start" }}>
                                        SQL Combo:&nbsp;
                                        <textarea style={{ ...inpSm, width: "220px", height: "38px", resize: "vertical", fontFamily: "monospace" }}
                                          value={f.sql_combo ?? ""}
                                          placeholder={"SELECT id AS value, descripcion FROM ...\nUSE @ValorPadre for dependent"}
                                          placeholder={"SELECT id AS value, descripcion FROM ...\nPuede usar {{Empresa}} y @ValorPadre"}
                                          onChange={(e) => changeFiltro(i, "sql_combo", e.target.value)} />
                                      </label>
                                    )}

                                    {/* Botón gestionar opciones — para tipoCombo=1 o 2 */}
                                    {(f.tipoCombo === 1 || f.tipoCombo === "1") && (
                                      <button onClick={() => setComboModalFiltro(i)}
                                        style={{ background: "#eff6ff", border: "1px solid #93c5fd", borderRadius: "4px", padding: "3px 10px", cursor: "pointer", color: "#1d4ed8", fontSize: "10px", fontWeight: "600" }}>
                                        📋 Gestionar opciones ({(f.opciones || []).length})
                                      </button>
                                    )}

                                    {/* Es dependiente */}
                                    <label style={chkLbl}>
                                      <input type="checkbox" checked={f.esDependiente == 1}
                                        onChange={(e) => {
                                          const isDep = e.target.checked ? 1 : 0;
                                          changeFiltro(i, "esDependiente", isDep);
                                        }} />
                                      Es Dependiente
                                    </label>

                                    {/* Depende de — solo visible si esDependiente */}
                                    {f.esDependiente == 1 && (
                                      <label style={chkLbl}>
                                        Depende de:&nbsp;
                                        <select style={{ ...inpSm, width: "120px" }} value={f.dependeDe ?? ""}
                                          onChange={(e) => changeFiltro(i, "dependeDe", e.target.value ? Number(e.target.value) : null)}>
                                          <option value="">— Seleccione —</option>
                                          {form.filtros.map((fi, fi_i) => {
                                            if (fi_i === i) return null;
                                            const val = fi.id || -(fi_i + 1);
                                            return <option key={fi_i} value={val}>{fi.label || `Filtro ${fi_i + 1}`}</option>;
                                          })}
                                        </select>
                                      </label>
                                    )}

                                  </div>
                                </td>
                              </tr>
                            )}
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </Accordion>

              {/* ── Columnas ── */}
              <Accordion title="Columnas" count={form.columnas.length} defaultOpen={true}>
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px" }}>
                  <BtnGeneral bg="teal" padding="3px 10px" radius="4px" fs="11px" fw="600" onClick={addColumna}>
                    + Añadir
                  </BtnGeneral>
                </div>
                {form.columnas.length > 0 && (
                  <table style={tbl}>
                    <thead>
                      <tr style={{ background: "#f8fafc" }}>
                        <th style={th}>Campo SQL</th>
                        <th style={th}>Etiqueta</th>
                        <th style={th}>Tipo Dato</th>
                        <th style={th}>Orden</th>
                        <th style={{ ...th, textAlign: "center" }}>Visible</th>
                        <th style={{ ...th, width: "28px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {form.columnas.map((c, i) => (
                        <tr key={i} style={{ borderTop: "1px solid #f1f5f9" }}>
                          <td style={td}><input style={inpSm} value={c.campo_resultado} placeholder="nombre_campo" onChange={(e) => changeColumna(i, "campo_resultado", e.target.value)} /></td>
                          <td style={td}><input style={inpSm} value={c.label} placeholder="Nombre visible" onChange={(e) => changeColumna(i, "label", e.target.value)} /></td>
                          <td style={td}>
                            <select style={inpSm} value={c.tipo_dato || "text"} onChange={(e) => changeColumna(i, "tipo_dato", e.target.value)}>
                              {tiposDato.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                            </select>
                          </td>
                          <td style={{ ...td, width: "52px" }}>
                            <input type="number" style={{ ...inpSm, width: "50px" }} value={c.orden ?? 0} onChange={(e) => changeColumna(i, "orden", parseInt(e.target.value))} />
                          </td>
                          <td style={{ ...td, textAlign: "center" }}>
                            <input type="checkbox" checked={c.visible !== 0}
                              onChange={(e) => changeColumna(i, "visible", e.target.checked ? 1 : 0)} />
                          </td>
                          <td style={{ ...td, textAlign: "center" }}>
                            <button onClick={() => removeColumna(i)} style={btnDel}>✕</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </Accordion>
            </>
          )}
        </Right>
      </div>

      {/* ── Modal de opciones fijas ── */}
      {comboModalFiltro !== null && form.filtros[comboModalFiltro] && (
        <ComboOptionsModal
          filtro={form.filtros[comboModalFiltro]}
          filtroIdx={comboModalFiltro}
          onClose={() => setComboModalFiltro(null)}
          onSave={handleSaveOpciones}
        />
      )}
    </Page>
  );
}

function Row({ lbl, top, children }) {
  return (
    <div style={{ display: "flex", alignItems: top ? "flex-start" : "center", gap: "8px", marginBottom: "1px" }}>
      <label style={{ minWidth: "100px", fontSize: "11px", color: "#64748b", textAlign: "right", flexShrink: 0, paddingTop: top ? "5px" : 0 }}>{lbl}</label>
      {children}
    </div>
  );
}

const inp = { flex: 1, padding: "3px 7px", borderRadius: "4px", border: "1px solid #cbd5e1", fontSize: "11px", boxSizing: "border-box", outline: "none", marginBottom: 0 };
const inpSm = { width: "100%", padding: "3px 5px", borderRadius: "3px", border: "1px solid #e2e8f0", fontSize: "11px", boxSizing: "border-box", outline: "none" };
const tbl = { width: "100%", borderCollapse: "collapse", fontSize: "11px" };
const th = { padding: "3px 6px", fontWeight: "600", color: "#64748b", textAlign: "left", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.04em" };
const td = { padding: "2px 4px", verticalAlign: "middle" };
const btnAdd = { background: "none", border: "1px dashed #94a3b8", borderRadius: "4px", padding: "2px 8px", cursor: "pointer", color: "#64748b", fontSize: "10px" };
const btnDel = { background: "none", border: "none", cursor: "pointer", color: "#ef4444", fontSize: "12px", padding: "0 3px" };
const chkLbl = { display: "flex", alignItems: "center", gap: "4px", fontSize: "11px", color: "#475569", cursor: "pointer" };
